import { useQuery } from '@hooks/reactQuery';

import { getHistoryCheckConfigTypes } from '@api/hitoryCheck';

import { extractQueryParams } from '@utils/common';
import { nameTitleToOptionFormatted } from '@utils/formatter';

import { ICMMavenirVendor } from '@interfaces/cmModule/cmModule';
import { TCMConfigTypesDTO } from '@interfaces/cmModule/dto/cmModuleDTO';
import { TNameTitle } from '@interfaces/common/common';
import { TSelectOption } from '@interfaces/components/componentTypes';

import { refetchOptions } from '@constants/common';
import { HISTORY_CHECK_CONFIG_TYPES } from '@constants/queryKeys';

type TUseQueryHistoryCheckConfig = ICMMavenirVendor & TCMConfigTypesDTO

interface IUseQueryHistoryCheckConfigTypesReturnValue {
	configTypeOptions: TSelectOption[];
	isLoadingConfigTypeOptions: boolean;
}

export const useQueryHistoryCheckConfigTypes = (
	params: TUseQueryHistoryCheckConfig,
): IUseQueryHistoryCheckConfigTypesReturnValue => {
	const {
		vendor,
		nodes,
		version,
		isMavenirVendor,
	} = params;

	const {
		data,
		isFetching,
		isLoading,
	} = useQuery<TNameTitle[], TSelectOption[]>({
		queryKey: [HISTORY_CHECK_CONFIG_TYPES, params],
		queryFn: extractQueryParams(getHistoryCheckConfigTypes),
		select: nameTitleToOptionFormatted,
		enabled: [
			!!vendor,
			!!nodes,
			!!version,
			isMavenirVendor,
		],
		...refetchOptions,
	});

	return {
		configTypeOptions: data || [],
		isLoadingConfigTypeOptions: (isLoading && !!data) || isFetching,
	};
};
